// src/components/Spinner.js
import { motion } from "framer-motion";

const Spinner = ({ size = 16 }) => (
  <motion.div
    style={{
      width: size,
      height: size,
      border: "2px solid #999",
      borderTop: "2px solid #333",
      borderRadius: "50%",
      margin: "auto",
      display: "inline-block"

    }}
    initial={{ rotate: 0 }} // 👈 FALTABA ESTO
    animate={{ rotate: 360 }}
    transition={{ repeat: Infinity, duration: 0.6, ease: "linear" }}
  />
);

export default Spinner;
